<template>
    <div>
        <!-- <b-alert :show="!!errorHandlingMessage" variant="danger" dismissible>{{ errorHandlingMessage }}</b-alert> -->
        <core-error-alerts :errors="errorMsgList"></core-error-alerts>
        
        <transition name="fade-fast" mode="out-in">
        
            <busy-spinner v-if="loading" key="loadingTrue" inner-class="my-4" text="Loading..."></busy-spinner>

            <div v-else key="loadingFalse">
                
                <p class="text-muted font-size-70 font-italic">Submitted by <span class="text-dark font-weight-500">{{ replyData.submitted_by_name }}</span> on {{ formatDateTime(replyData.submitted_on) }}</p>
                
                <b-table
                    v-if="formiumItems.length"
                    key="hasData"
                    :items="formiumItems"
                    :fields="columns"
                    class="no-top-border"
                >
                    <!-- <template #cell(value)="data">
                        <div style="white-space: pre-wrap;">
                            {{ data.value }}
                        </div>
                    </template> -->
                </b-table>

                <div
                    v-else
                    key="noData"
                >
                    <h6 class="text-center text-muted">There are no questions on this form</h6>
                </div>

                <!-- <pre>{{ replyData }}</pre> -->
            </div>
        
        </transition>
    </div>
</template>

<script>
import { suppliosApi } from '../../js/api-service';
import { errorHandling } from '../../js/custom-vue-mixins';
//import { DateTime } from 'luxon';
import { FormatDateTimeLocal } from '../../js/filters-helpers';
import { itemTypes } from '../../js/formium-helpers';  // canonical list of formium fields for frontend -- ARRAY

const formiumItemSlugFormatterMap = new Map(itemTypes.map(fit => [fit.value, fit.valueStringFormatter]));  // Map() of formium_item_slug: valueStringFormatter function (pass in the value)
// use this to get the formatter function -- formatterFunction = formiumItemSlugFormatterMap.get(the_slug)

export default {
    name: 'FormiumReplyViewer',
    components: {},
    mixins: [
        errorHandling,
    ],
    props: {
        replyId: {
            type: [String, Number],
            required: true,
        }
    },
    data: function() {
        return {
            loading: true,  // set to true for this, so it always starts in loading mode
            replyData: {},  // put here from API
            formiumItems: [], // put all formium items here after getting from API (has questions and answers)
            columns: [
                {
                    key: 'label',
                    label: 'Question',
                    thClass: 'min-width-200',  // using this to set a min width for the question column
                    tdClass: 'font-weight-bold',
                },
                {
                    key: 'value',
                    label: 'Vendor Response',
                    tdClass: 'text-show-breaks',
                }
            ]
        }
    },
    computed: {

    },
    mounted: function() {
        this.getReply();
    },
    methods: {
        // use this.apiErrorHandler(error, extraMsg, localMsg) from mixin - localMsg is bool, if true puts message in this.errorHandlingMessage
        getReply: function() {
            this.loading = true;
            return suppliosApi.formiumReply.retrieve(this.replyId)
                .then(response => {
                    this.replyData = response.data;
                    this.formiumItems = this.buildRowsForTable(response.data.formium_fields);
                    // OLD this.formiumItems = this.replyData.formium_fields;
                    return true;
                })
                .catch(error => {
                    this.apiErrorHandler(error, null, true);
                    return false;
                })
                .then(success => {
                    this.loading = false; 
                    return success;
                });
        },
        buildRowsForTable: function(formiumItemsFromApi) {
            // pass in list of formium items with answers from API, this will transform it and return it in format we want
            // run things through formatters, build a new array of objects to pass to table
            let formiumItemsForTable = [];  // build this up and return it
            formiumItemsFromApi.forEach(fi => {
                let itemForTable = {id: fi.id, label: fi.label};  // pull out 'id' and 'label'
                const valueFormatter = formiumItemSlugFormatterMap.get(fi.field_type_slug);  // get the formatter function from our canonical list
                itemForTable['value'] = valueFormatter(fi.value);
                // maybe also get some css classes to add to the value cell? another field in your lookup list
                formiumItemsForTable.push(itemForTable);
            });
            return formiumItemsForTable;
        },
        formatDateTime: function(value) {
            return FormatDateTimeLocal(value);
        },
    }
}
</script>

<style>

</style>